import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DataOptions, DependOnOption, DisabledType } from '../common'

export class SelectboxDef {
  key?: string = uuid()
  type: 'selectbox' = 'selectbox'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: SelectboxOptions = new SelectboxOptions()
  rules?: Rule[]
}

export class SelectboxOptions {
  defaultValue?: Array<string | number> = []
  disabled?: DisabledType = false
  labelWidth?: string | number
  required?: boolean = false
  showLabel?: boolean = true
  options?: DataOptions = {}
  selectOptions?: []
  itemTips?: string
  showQuestionIcon?: boolean = false
  onCheckBoxChange?: (value: any, form: Record<string, any>) => void
  questionIconFn?: (item: Record<string, any>) => void
}
